export const ACCOUNT_ACCESS_TOKENS = 'access_tokens'
export const ACCOUNT_ACCESS_TOKENS_EU = 'access_tokens_eu'
export const ACCOUNT_ACCESS_TOKENS_US = 'access_tokens_us'
export const ACCOUNT_CODE_VERIFIER = 'code-verifier'
export const ACCOUNT_OATH_STATE = 'oauth_state'
export const ACCOUNT_PAGE_NAME = 'account'
